import { Component, OnInit } from '@angular/core';
import { SubscriptionService } from 'src/app/services/subscription/subscription.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-mobilepackagesitemap',
  templateUrl: './mobilepackagesitemap.component.html',
  styleUrls: ['./mobilepackagesitemap.component.css']
})
export class MobilepackagesitemapComponent implements OnInit {

  Submitted: boolean = false;
  PackageList: any;
  PackageSiteMapList: any;
  MenuTypeList:any;
  UserTypeList:any;
  

  constructor(private subcriptionService: SubscriptionService, private LookupService: LookupService,
     public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }


  SiteMapModel = {
    IsActive: true,
    PackageID: 0,
    UserTypeID:0,
    MenuTypeID:0,

  };

  ClearList() {
    this.PackageSiteMapList = [];
};

ClearPackageSiteMap() {
    this.Submitted = false;
    this.PackageSiteMapList = [];
    this.SiteMapModel.PackageID = 0;
    this.SiteMapModel.UserTypeID = 0;
    this.SiteMapModel.MenuTypeID = 0;
};

 
ValidityState() {
    return this.SiteMapModel.UserTypeID == 0 || this.SiteMapModel.PackageID == 0 || this.SiteMapModel.MenuTypeID == 0;
}

SaveMobilePackageSiteMap() {
  this.Submitted = true;
  if (!this.ValidityState() && this.PackageSiteMapList != null && this.PackageSiteMapList.length>0) {
    this.spinnerService.show();
      this.subcriptionService.SaveMobilePackageSiteMap(JSON.stringify(this.SiteMapModel), JSON.stringify(this.PackageSiteMapList)).subscribe((data: any) => {
          this.GetAllMobilePackageSiteMap();
          this.spinnerService.hide();
          this.Submitted = false;  
          this.globalHelper.CheckActionStatus(data);

      });
  }
}
 

  GetAllMobilePackageSiteMap() {
    this.Submitted = true;
    this.PackageSiteMapList=[];
    if (!this.ValidityState()){
    this.spinnerService.show();
    this.subcriptionService.GetAllMobilePackageSiteMap(JSON.stringify(this.SiteMapModel)).subscribe((data: any) => {
      this.PackageSiteMapList = data.PackageSiteMapList;
      this.spinnerService.hide();
      this.Submitted = false;
    });
    }

  }
  

  // Init and Lookup

  ngOnInit() {

    this.GetAllPackage();
    this.GetAllUserType();
    this.GetAllMenuType();
   
  }


  GetAllPackage() {

    this.LookupService.GetLookupsList('PackageAll', '').subscribe((data: any) => {
      this.PackageList = data.LookupItems;
    });
  }

  GetAllUserType() {

    this.LookupService.GetLookupsList('UserType', '').subscribe((data: any) => {
      this.UserTypeList = data.LookupItems;
    });
  }

  GetAllMenuType() {

    this.LookupService.GetLookupsList('MenuType', '').subscribe((data: any) => {
      this.MenuTypeList = data.LookupItems;
    });
  }

 

}



